import { Mesh } from "./Mesh";
export class MutableMesh {
    constructor() {
        this.vertices = [];
        this.indices = [];
    }
    vertexCount() {
        return this.vertices.length;
    }
    triangleCount() {
        return this.indices.length / 3;
    }
    createVertex(pos, color = undefined) {
        const vertex = { pos, color_rgba: color ?? [255, 255, 255, 255] };
        this.vertices.push(vertex);
        return { index: this.vertices.length - 1, vertex };
    }
    triangle(v0, v1, v2) {
        this.indices.push(v0.index, v1.index, v2.index);
        this.indices.push(v0.index, v2.index, v1.index);
    }
    quad(v0, v1, v2, v3) {
        this.indices.push(v0.index, v1.index, v2.index, v0.index, v2.index, v3.index);
        this.indices.push(v0.index, v2.index, v1.index, v0.index, v3.index, v2.index);
    }
    translate(offset) {
        this.vertices.forEach(v => {
            v.pos.x += offset.x;
            v.pos.y += offset.y;
            v.pos.z += offset.z;
        });
        return this;
    }
    scale(scale) {
        this.vertices.forEach(v => {
            v.pos.x *= scale;
            v.pos.y *= scale;
            v.pos.z *= scale;
        });
        return this;
    }
    recolor(color) {
        this.vertices.forEach(v => v.color_rgba = color);
        return this;
    }
    add(...meshes) {
        for (const mesh of meshes) {
            const mapped_indices = mesh.indices.map(i => i + this.vertices.length);
            this.vertices.push(...mesh.vertices);
            this.indices.push(...mapped_indices);
        }
        return this;
    }
    finalize() {
        return new Mesh([...this.vertices], [...this.indices]);
    }
}
